/* eslint-disable no-unused-vars */
/* eslint-disable spaced-comment */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import "./start-config-button.scss";
import { useDispatch } from "react-redux";
import { BiLoaderAlt } from "react-icons/bi";
import t from "../../../utils/translation/translator";
import { getAllSteps } from "../../../store/utils/utils";
import { updateConfiguration } from "../../../store/slices/common";
import { useSaveConfiguration } from "../StartConfigurationUtil";

const StartConfigButton = ({
  title,
  description,
  type,
  idLabel,
  configurationInProgress,
  handleDisplayContinuePopup
}) => {
  const dispatch = useDispatch();
  const steps = getAllSteps();

  const getCurrentStep = () => {
    switch (type) {
      case "RETROFIT":
        return steps.retrofit.APPLICATION_SETTINGS;
      case "CARTESIAN":
        return steps.cartesian.KINEMATICS;
      case "MC12":
        return steps.mc12.BUILD_TRACK;
      case "INTEGRATED_DRIVES":
        return steps.integratedDrives.SPECIFY_AND_CONFIGURE;
      default:
        return steps.retrofit.APPLICATION_SETTINGS;
    }
  };

  const { execSave, isLoadingStartConfiguration, isFetchingStartConfiguration } = useSaveConfiguration(type);

  const [appLoading, setAppLoading] = useState(false);
  const [isSelected, setSelected] = useState(false);

  const handleClickOnTechnologyCard = () => {
    if (configurationInProgress) {
      console.log("continue");
      handleDisplayContinuePopup(configurationInProgress);
    } else {
      handleStartNewConfiguration();
    }
  };

  const handleStartNewConfiguration = async () => {
    setSelected(true);
    await execSave();
    dispatch(updateConfiguration());
  };

  useEffect(() => {
    setAppLoading(isLoadingStartConfiguration || isFetchingStartConfiguration);
  }, [isLoadingStartConfiguration, isFetchingStartConfiguration]);

  return (
    <div
      id={`start-card-${idLabel}`}
      onClick={() => handleClickOnTechnologyCard()}
      className={`start-config-button group md:flex-1 bg-white p-4 space-y-3 shadow-lg rounded-lg border-[1px] border-solid 
                border-gray-200 !border-t-8 hover:shadow-xl hover:border-t-primary transition-all duration-200 
                cursor-pointer select-none hover:-translate-y-2 
                max-w-md flex flex-col
                ${appLoading ? "opacity-50 pointer-events-none" : ""}`}
    >
      <span className="mt-2 text-lg font-bold">{title}</span>
      <div className=" text-sm text-gray-500">{description}</div>
      <div
        className="text-sm flex justify-end items-center text-secondary flex-1
"
      >
        {isSelected && (isLoadingStartConfiguration || isFetchingStartConfiguration) ? (
          <BiLoaderAlt className="animate-spin text-secondary text-lg" />
        ) : (
          <span className="font-semibold group-hover:underline">{t("msizer.ui.start-config-card-button")}</span>
        )}
      </div>
    </div>
  );
};

StartConfigButton.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  idLabel: PropTypes.string.isRequired
};

export default StartConfigButton;
